import { render, staticRenderFns } from "./SmsApp.vue?vue&type=template&id=6071e096&scoped=true"
import script from "./SmsApp.vue?vue&type=script&lang=js"
export * from "./SmsApp.vue?vue&type=script&lang=js"
import style0 from "./SmsApp.vue?vue&type=style&index=0&id=6071e096&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6071e096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6071e096')) {
      api.createRecord('6071e096', component.options)
    } else {
      api.reload('6071e096', component.options)
    }
    module.hot.accept("./SmsApp.vue?vue&type=template&id=6071e096&scoped=true", function () {
      api.rerender('6071e096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifihistory/SmsApp.vue"
export default component.exports